import { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';
import { gtm } from 'utils/gtm';

import jobListClasses from '../list/index.module.css';
import classes from './InDemandJobsList.module.css';

const propTypes = {
  inDemandJobs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      jobsPageLink: PropTypes.string,
      locationsPageLink: PropTypes.string,
      resumePageLink: PropTypes.string,
    })
  ),
  title: PropTypes.string,
  standardSideBar: PropTypes.bool,
  TitleTagName: PropTypes.string,
  classNames: PropTypes.string,
  src: PropTypes.string,
};

const defaultProps = {
  inDemandJobs: [],
  TitleTagName: 'h3',
  src: '',
};

const InDemandJobsList = ({
  inDemandJobs,
  title,
  className,
  standardSideBar,
  TitleTagName,
  src,
}) => {
  const onMainLinkClick = () => {
    gtm.logJobCalloutClick(src);
  }

  // Uppercase the first letter of each job title.
  inDemandJobs.forEach((job) => {
    if (!job.title) return;
    job.title = job.title.charAt(0).toUpperCase() + job.title.slice(1).toLowerCase();
  });

  return (
    <div
      id="jobs-callout"
      className={classNames(jobListClasses['job-list-container'], className, {
        [jobListClasses.standardSideBar]: standardSideBar,
      })}
    >
      <TitleTagName className={classNames(jobListClasses.subtitle, 'text-capitalize')}>
        {title || `Recent job searches`}
      </TitleTagName>
      <ul className={classNames(jobListClasses['job-list'], 'text-capitalize')}>
        {inDemandJobs.map((job) => (
          <li key={job.title} className={jobListClasses['job-list-item']}>
            <div className="list-link">
              {job.jobsPageLink && (
                <a href={job.jobsPageLink + src} className="list-link" onClick={onMainLinkClick}>
                  {' '}
                  {`${job.title} jobs`}
                </a>
              )}
              {job.companyLink && (
                <a href={job.companyLink + src} className="list-link" onClick={onMainLinkClick}>
                  {' '}
                  {`${job.companyName} jobs`}
                </a>
              )}
            </div>
            <div className={jobListClasses['job-list-item-data']}>
              {job.resumePageLink && (
                <label className="location">
                  <a
                    href={job.resumePageLink + src}
                    title={`${job.title || job.companyName || ''} resume`}
                    className={classes.jobListLink}
                  >
                    {`Resume`}
                  </a>
                </label>
              )}
              {job.comboCityCompanyLink && (
                <label className="location">
                  <a
                    href={job.comboCityCompanyLink + src}
                    className={classes.jobListLink}
                    title={`${job.title ? job.title : job.companyName} jobs by location`}
                  >{`Location`}</a>
                </label>
              )}
              {job.resumePageLink && job.locationsPageLink && <label className="dot-separator" />}
              {job.locationsPageLink && (
                <label className="location">
                  <a
                    href={job.locationsPageLink + src}
                    className={classes.jobListLink}
                    title={`${job.title ? job.title : job.companyName} Jobs by location`}
                  >{`Location`}</a>
                </label>
              )}
              {(job.resumePageLink || job.locationsPageLink) &&
                (job.comboCityPageLink || job.comboTitleCompanyLink) && (
                  <label className="dot-separator" />
                )}
              {job.comboCityPageLink && (
                <label className="location">
                  <a href={job.comboCityPageLink + src} className={classes.jobListLink}>
                    {job.city}
                  </a>
                </label>
              )}
              {job.comboTitleCompanyLink && (
                <label className="location">
                  <a
                    href={job.comboTitleCompanyLink + src}
                    className={classes.jobListLink}
                  >{`${job.title} ${job.companyName} jobs`}</a>
                </label>
              )}
            </div>
          </li>
        ))}
      </ul>
      <a href={"/jobs/" + src} className="mt-1">
        <ZpButton theme="primary" size="big" isFullWidth>
          Explore All Jobs
        </ZpButton>
      </a>
    </div>
  );
};

InDemandJobsList.propTypes = propTypes;
InDemandJobsList.defaultProps = defaultProps;

export default memo(InDemandJobsList);
